import {
  useGoalsServiceGoalsControllerGetAllKey,
  useGoalsServiceGoalsControllerGetKey,
  useGoalsServiceGoalsControllerGetSavedValueKey,
  useGoalsServiceGoalsControllerGetStepsKey,
} from '@/__generated__/queries'

import { INSIGHTS_QUERY_KEY } from '@/hooks/useInsightsQuery.hook'

export const INVALIDATE_KEYS = [
  useGoalsServiceGoalsControllerGetAllKey,
  useGoalsServiceGoalsControllerGetSavedValueKey,
  useGoalsServiceGoalsControllerGetKey,
  useGoalsServiceGoalsControllerGetStepsKey,
  INSIGHTS_QUERY_KEY,
]
